import React from 'react'
import Welcome from './Welcome'
import PersonalInfo from './PersonalInfo'
import Survey from './Survey'
import HormonalAutoImmune from './HormonalAutoImmune'
import CompleteProfile from './CompleteProfile'
import HearAbout from './HearAbout'
import TalkAboutCoverage from './TalkAboutCoverage'
import InsuranceCardInfo from './InsuranceCardInfo'
import InsuranceHomeAddress from './InsuranceHomeAddress'
import ScheduledTime from './ScheduledTime'
import ComingSoon, { ComingSoonReason } from './ComingSoon'
import InsuranceNotAcceptedNoCashPay from './InsuranceNotAcceptedNoCashPay'
import PrimaryCarePhysician from './PrimaryCarePhysician'
import PhysicianDetail from './PhysicianDetail'
import PhysicianConfirmation from './PhysicianConfirmation'
import CardOnFile from './CardOnFile'
import CashPay from './CashPay'
import VerifyEmail from './VerifyEmail'
import PrescreenQuestions from './PrescreenQuestions'
import SkuCongratulations from './WLC/SkuCongratulations'
import PastDiagnosis from './WLC/PastDiagnosis'
import RehabQuestion1 from './Rehab/Question1/index'
import RehabQuestion2 from './Rehab/Question2/index'
import RehabConsultProvider from './Rehab/RehabConsultProvider/index'
import RehabCongratulations from './Rehab/Congratulations/index'
import PainLocated from './Rehab/PainLocated/index'
import InsuranceCard from './InsuranceCard'
import Unavailable from './Unavailable'
import UhOh from './UhOh'
import WLCCondition from './MCA/WLCCondition'
import WLCExclusion from './MCA/WLCExclusion'
import MSKPainQualifier from './MCA/MSKPainQualifier'
import MSKExclusion from './MCA/MSKExclusion'
import MBINotFound from './MCA/MBINotFound'
import ThanksForYourInterest from './MCA/ThanksForYourInterest'
import Eligible from './MCA/Eligible'
import PrimaryCareProvider from './MCA/PrimaryCareProvider'
import AlreadyEnrolled from './MCA/AlreadyEnrolled'
import VerifyWithClearFailure from './MCA/VerifyWithClearFailure'
import AlignmentFailed from './MCA/AlignmentFailed'
import VerifyWithClear from './MCA/VerifyWithClear'
import NotEligible from './NotEligible'
import GenericScreen from './MCA/GenericScreen'

export const ScreenKey = {
  WELCOME: 'welcome',
  PERSONAL_INFO: 'personalInfo',
  SURVEY: 'survey',
  HORMONAL_AUTOIMMUNE: 'hormonalAutoImmune',
  COMPLETE_PROFILE: 'completeProfile',
  HEAR_ABOUT: 'hearAbout',
  TALK_ABOUT_COVERAGE: 'talkAboutCoverage',
  INSURANCE_CARD_INFO: 'insuranceCardInfo',
  INSURANCE_HOME_ADDRESS: 'insuranceHomeAddress',
  SCHEDULED_TIME: 'scheduledTime',
  INSURANCE_NOT_ACCEPTED: 'insuranceNotAccepted',
  INSURANCE_NOT_ACCEPTED_NO_CASH_PAY: 'insuranceNotAcceptedNoCashPay',
  PRIMARY_CARE_PHYSICIAN: 'primaryCarePhysician',
  PHYSICIAN_DETAIL: 'physicianDetail',
  PHYSICIAN_CONFIRMATION: 'physicianConfirmation',
  CARD_ON_FILE: 'cardOnFile',
  CASH_PAY: 'cashPay',
  APPOINTMENT_CONFIRM: 'appointmentConfirm',
  VERIFY_EMAIL: 'verifyEmail',
  PRESCREEN_QUESTIONS: 'welcomeNew',
  SKU_CONGRATULATIONS: 'congratulationsSku',
  PAST_DIAGNOSIS: 'pastDiagnosis',
  REHAB_QUESTION_1: 'rehabQuestion1',
  REHAB_QUESTION_2: 'rehabQuestion2',
  REHAB_CONSULT_PROVIDER: 'rehabConsultProvider',
  REHAB_CONGRATULATIONS: 'rehabCongratulations',
  PAIN_LOCATED: 'painLocated',
  INSURANCE_CARD: 'insuranceCard',
  UNAVAILABLE: 'unavailable',
  UH_OH: 'uhOh',
  MCA_WLC_CONDITION: 'mcaWlcCondition',
  MCA_WLC_EXCLUSION: 'mcaWlcExclusion',
  MCA_MSK_PAIN_QUALIFIER: 'mcaMskPainQualifier',
  MCA_MSK_EXCLUSION: 'mcaMskExclusion',
  MCA_MBI_NOT_FOUND: 'mcaMbiNotFound',
  MCA_THANKS_FOR_YOUR_INTEREST: 'mcaThanksForYourInterest',
  MCA_VERIFY_WITH_CLEAR_FAILURE: 'mcaVerifyWithClearFailure',
  MCA_ELIGIBLE: 'mcaEligible',
  MCA_PRIMARY_CARE_PROVIDER: 'mcaPrimaryCareProvider',
  MCA_ABOUT_YOU: 'mcaAboutYou',
  MCA_ALREADY_ENROLLED: 'mcaAlreadyEnrolled',
  MCA_ALIGNMENT_FAILED: 'mcaAlignmentFailed',
  MCA_VERIFY_WITH_CLEAR: 'mcaVerifyWithClear',
  MCA_COMING_SOON_STATE: 'mcaComingSoonState',
  NOT_ELIGIBLE: 'notEligible',
  GENERIC_SCREEN: 'genericScreen',
}

export const CashPayVariants = ['PLAYFREE']

export const openScreen = (key, props) => {
  switch (key) {
    case ScreenKey.WELCOME:
      return <Welcome {...props} />
    case ScreenKey.PERSONAL_INFO:
      return <PersonalInfo {...props} />
    case ScreenKey.SURVEY:
      return <Survey {...props} />
    case ScreenKey.HORMONAL_AUTOIMMUNE:
      return <HormonalAutoImmune {...props} />
    case ScreenKey.COMPLETE_PROFILE:
      return <CompleteProfile {...props} />
    case ScreenKey.HEAR_ABOUT:
      return <HearAbout {...props} />
    case ScreenKey.TALK_ABOUT_COVERAGE:
      return <TalkAboutCoverage {...props} />
    case ScreenKey.INSURANCE_CARD_INFO:
      return <InsuranceCardInfo {...props} />
    case ScreenKey.INSURANCE_HOME_ADDRESS:
      return <InsuranceHomeAddress {...props} />
    case ScreenKey.SCHEDULED_TIME:
      return <ScheduledTime {...props} />
    case ScreenKey.INSURANCE_NOT_ACCEPTED:
      return <ComingSoon {...props} reason={ComingSoonReason.INSURANCE} />
    case ScreenKey.INSURANCE_NOT_ACCEPTED_NO_CASH_PAY:
      return <InsuranceNotAcceptedNoCashPay {...props} />
    case ScreenKey.PRIMARY_CARE_PHYSICIAN:
      return <PrimaryCarePhysician {...props} />
    case ScreenKey.PHYSICIAN_DETAIL:
      return <PhysicianDetail {...props} />
    case ScreenKey.PHYSICIAN_CONFIRMATION:
      return <PhysicianConfirmation {...props} />
    case ScreenKey.CARD_ON_FILE:
      return <CardOnFile {...props} />
    case ScreenKey.CASH_PAY:
      return <CashPay {...props} />
    case ScreenKey.VERIFY_EMAIL:
      return <VerifyEmail {...props} />
    case ScreenKey.PRESCREEN_QUESTIONS:
      return <PrescreenQuestions {...props} />
    case ScreenKey.SKU_CONGRATULATIONS:
      return <SkuCongratulations {...props} />
    case ScreenKey.PAST_DIAGNOSIS:
      return <PastDiagnosis {...props} />
    case ScreenKey.REHAB_QUESTION_1:
      return <RehabQuestion1 {...props} />
    case ScreenKey.REHAB_QUESTION_2:
      return <RehabQuestion2 {...props} />
    case ScreenKey.REHAB_CONSULT_PROVIDER:
      return <RehabConsultProvider {...props} />
    case ScreenKey.REHAB_CONGRATULATIONS:
      return <RehabCongratulations {...props} />
    case ScreenKey.PAIN_LOCATED:
      return <PainLocated {...props} />
    case ScreenKey.INSURANCE_CARD:
      return <InsuranceCard {...props} />
    case ScreenKey.UNAVAILABLE:
      return <Unavailable {...props} />
    case ScreenKey.UH_OH:
      return <UhOh {...props} />
    case ScreenKey.MCA_WLC_CONDITION:
      return <WLCCondition {...props} />
    case ScreenKey.MCA_WLC_EXCLUSION:
      return <WLCExclusion {...props} />
    case ScreenKey.MCA_MSK_PAIN_QUALIFIER:
      return <MSKPainQualifier {...props} />
    case ScreenKey.MCA_MSK_EXCLUSION:
      return <MSKExclusion {...props} />
    case ScreenKey.MCA_MBI_NOT_FOUND:
      return <MBINotFound {...props} />
    case ScreenKey.MCA_THANKS_FOR_YOUR_INTEREST:
      return <ThanksForYourInterest {...props} />
    case ScreenKey.MCA_VERIFY_WITH_CLEAR_FAILURE:
      return <VerifyWithClearFailure {...props} />
    case ScreenKey.MCA_ELIGIBLE:
      return <Eligible {...props} />
    case ScreenKey.MCA_PRIMARY_CARE_PROVIDER:
      return <PrimaryCareProvider {...props} />
    case ScreenKey.MCA_ALREADY_ENROLLED:
      return <AlreadyEnrolled {...props} />
    case ScreenKey.MCA_ALIGNMENT_FAILED:
      return <AlignmentFailed {...props} />
    case ScreenKey.MCA_VERIFY_WITH_CLEAR:
      return <VerifyWithClear {...props} />
    case ScreenKey.MCA_COMING_SOON_STATE:
      return <ComingSoon {...props} reason={ComingSoonReason.MCA_STATE} />
    case ScreenKey.NOT_ELIGIBLE:
      return <NotEligible {...props} />
    case ScreenKey.GENERIC_SCREEN:
      return <GenericScreen {...props} />
    default:
      return <></>
  }
}

export const UploadSelectionOptionType = {
  HELP_MOST_OPTION: 1,
  DISEASE_HELP_OPTION: 2,
  HEAR_ABOUT_OPTION: 3,
  INSURANCE_PROVIDER_OPTION: 4,
}

// added for reminder
// eslint-disable-next-line no-unused-vars
const PageIndex = {
  1: ScreenKey.WELCOME,
  2: ScreenKey.PERSONAL_INFO,
  3: ScreenKey.SURVEY,
  '3a': ScreenKey.HORMONAL_AUTOIMMUNE,
  5: ScreenKey.COMPLETE_PROFILE,
  6: ScreenKey.HEAR_ABOUT,
  7: ScreenKey.TALK_ABOUT_COVERAGE,
  '8a': ScreenKey.INSURANCE_CARD_INFO,
  '8b': ScreenKey.INSURANCE_HOME_ADDRESS,
  '9a': ScreenKey.INSURANCE_NOT_ACCEPTED,
  '9b': ScreenKey.INSURANCE_NOT_ACCEPTED_NO_CASH_PAY,
  '10a': ScreenKey.PRIMARY_CARE_PHYSICIAN,
  '10b': ScreenKey.PHYSICIAN_DETAIL,
  '10c': ScreenKey.PHYSICIAN_CONFIRMATION,
  '11a': ScreenKey.CARD_ON_FILE,
  '11b': ScreenKey.CASH_PAY,
  12: ScreenKey.SCHEDULED_TIME,
  13: ScreenKey.APPOINTMENT_CONFIRM,
  skuCongratulations: ScreenKey.SKU_CONGRATULATIONS,
  pastDiagnosis: ScreenKey.PAST_DIAGNOSIS,
  rehabQuestion1: ScreenKey.REHAB_QUESTION_1,
  rehabQuestion2: ScreenKey.REHAB_QUESTION_2,
  rehabConsultProvider: ScreenKey.REHAB_CONSULT_PROVIDER,
  rehabCongratulations: ScreenKey.REHAB_CONGRATULATIONS,
  painLocated: ScreenKey.PAIN_LOCATED,
  insuranceCard: ScreenKey.INSURANCE_CARD,
  unavailable: ScreenKey.UNAVAILABLE,
}

export const getInsuranceProviderForAmplitude = (item) => {
  switch (item?.id) {
    case 1:
      return 'Aetna'
    case 2:
      return 'BCBS'
    case 3:
      return 'Cigna'
    case 4:
      return 'United'
    case 5:
      return 'Self Pay'
    case 6:
      return `Other - ${item.otherText}`
    default:
      return ''
  }
}
